export default __webpack_public_path__ + "static/media/general.8c49e296.svg";